import {Chip} from '@mui/material';
import {styled} from '@mui/system';

export const CustomChip = styled(Chip)({
	'& .MuiChip-deleteIcon': {
		color: '#0B1627',
	},
});
